import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./util/localStorageUtil";
import reportWebVitals from "./reportWebVitals";
// import AppRouter from "./routes";
import App from "./App";
import { initAppInsights } from "./util/appInsights";


initAppInsights();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals(console.log);
